import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';

const PDFDocument = ({ 
    catalog, 
    products, 
    config, 
    colors,
    providerInfo,
    qrWhatsApp,
    qrCatalog,
    circularLogo
}) => {
    
    console.log('🎨 PDFDocument renderizando con config:', config);
    console.log('🎨 Texto de portada: CATÁLOGO DE 2050');
    
    // Las imágenes ya vienen convertidas a PNG desde PDFGenerateStep
    // Solo filtrar las que sean null o undefined
    const validProducts = products.map(product => ({
        ...product,
        imagenes: (product.imagenes || []).filter(img => img && img !== null)
    }));

    const styles = StyleSheet.create({
        page: {
            padding: 20,
            backgroundColor: '#ffffff',
            position: 'relative',
        },
        // Círculos decorativos de fondo para páginas de productos
        backgroundCircle1: {
            position: 'absolute',
            top: -200,
            right: -100,
            width: 400,
            height: 400,
            borderRadius: 200,
            backgroundColor: colors.secondary,
            opacity: 0.40,
        },
        backgroundCircle2: {
            position: 'absolute',
            top: 100,
            right: 300,
            width: 60,
            height: 60,
            borderRadius: 30,
            backgroundColor: colors.secondary,
            opacity: 0.40,
        },
        backgroundCircle3: {
            position: 'absolute',
            top: 50,
            left: -100,
            width: 200,
            height: 200,
            borderRadius: 100,
            backgroundColor: colors.secondary,
            opacity: 0.40,
        },
        backgroundCircle5: {
            position: 'absolute',
            bottom: 150,
            right: -150,
            width: 300,
            height: 300,
            borderRadius: 150,
            backgroundColor: colors.secondary,
            opacity: 0.40,
        },
        backgroundCircle6: {
            position: 'absolute',
            top: 400,
            right: 200,
            width: 90,
            height: 90,
            borderRadius: 45,
            backgroundColor: colors.secondary,
            opacity: 0.40,
        },
        coverPage: {
            padding: 0,
            backgroundColor: colors.primary,
            position: 'relative',
            width: '100%',
            height: '100%',
        },
        // Portada generada
        coverContent: {
            width: '100%',
            height: '100%',
            position: 'relative',
            justifyContent: 'center',
            alignItems: 'center',
        },
        coverSquare: {///
            position: 'absolute',
            bottom: 300,
            left: 190,
            width: 220,
            height: 220,
            backgroundColor: 'rgba(255,255,255,0.2)',
            transform: 'rotate(45deg)',
        },
        coverTriangle: {
            position: 'absolute',
            top: 775,
            right: -905,
            width: 0,
            height: 0,
            color: 'white',
            transform: 'rotate(-90deg)',
            // Con borderLeft y borderRight aumentas la BASE del triángulo (ancho)
            borderLeft: '450pt solid transparent',
            borderLeftColor: colors.primary,
            borderRight: '450pt solid transparent',
            borderRightColor: colors.primary,
            // Con borderBottom aumentas la ALTURA del triángulo
            borderBottom: '100pt solid rgba(255, 255, 255, 1)',
            transformOrigin: 'bottom left',
        },
        coverTitle: {
            fontSize: 16,
            color: 'rgba(255,255,255,0.9)',
            letterSpacing: 2,
            marginBottom: 8,
            textAlign: 'center',
            position: 'absolute',
            top: 100,
            left: 0,
            right: 0,
        },
        coverSubtitle: {
            fontSize: 32,
            color: '#ffffff',
            fontWeight: 'bold',
            letterSpacing: 1,
            textAlign: 'center',
            marginBottom: 20,
        },
        coverYear: {
            fontSize: 18,
            color: '#ffffff',
            fontWeight: 'bold',
            letterSpacing: 1,
            position: 'absolute',
            bottom: 80,
            left: 0,
            right: 0,
            textAlign: 'center',
        },
        coverImageContainer: {
            width: 220,
            height: 220,
            backgroundColor: '#ffffff',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 30
        },
        coverImage: {
            width: 210,
            height: 210,
            objectFit: 'contain',
        },
        coverImagePlaceholder: {
            width: 210,
            height: 210,
            backgroundColor: '#000000',
        },
        // Portada con banner
        bannerImage: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
        },
        // Productos - Layout Alternado
        productsContainerAlternado: {
            flexDirection: 'column',
            gap: 10,
            width: '100%',
        },
        productCardAlternado: {
            flexDirection: 'row',
            gap: 15,
            paddingVertical: 4,
            width: '100%',
            alignItems: 'stretch',
        },
        productCardAlternadoReverse: {
            flexDirection: 'row-reverse',
            gap: 15,
            paddingVertical: 4,
            width: '100%',
            alignItems: 'stretch',
        },
        productImageAlternado: {
            width: 160,
            height: 160,
            objectFit: 'cover',
        },
        productImageAlternadoPlaceholder: {
            width: 160,
            height: 160,
            backgroundColor: '#f0f0f0',
        },
        productInfoAlternado: {
            flex: 1,
            justifyContent: 'space-between',
        },
        productInfoAlternadoRight: {
            flex: 1,
            justifyContent: 'space-between',
            alignItems: 'flex-end',
        },
        // Productos - Doble Columna
        productsContainerDobleColumna: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 8,
        },
        productCardDobleColumna: {
            width: '48.5%',
            flexDirection: 'column',
            alignItems: 'center',
        },
        productImageDobleColumna: {
            width: '75%',
            aspectRatio: 1,
            objectFit: 'cover',
            marginBottom: 8,
        },
        productDetailsDobleColumna: {
            width: '75%',
        },
        productCategoryDobleColumna: {
            fontSize: 9.1,
            color: '#888',
            marginBottom: 2,
        },
        productNameDobleColumna: {
            fontSize: 18.2,
            fontWeight: 'bold',
            marginBottom: 2,
            color: '#000',
        },
        productCodeDobleColumna: {
            fontSize: 9.1,
            color: '#999',
            marginBottom: 4,
        },
        productDescriptionDobleColumna: {
            fontSize: 10.4,
            color: '#666',
            marginBottom: 6,
            lineHeight: 1.3,
        },
        productVariantsRowDobleColumna: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 4,
        },
        productVariantLabelDobleColumna: {
            fontSize: 9.1,
            color: '#666',
            fontWeight: 'bold',
            marginRight: 4,
            marginTop: 2,
        },
        productVariantBadgesDobleColumna: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 3,
            flex: 1,
        },
        productVariantBadgeDobleColumna: {
            backgroundColor: colors.primary,
            paddingHorizontal: 6,
            paddingVertical: 3,
            borderRadius: 3,
            marginRight: 3,
            marginBottom: 3,
        },
        productVariantTextDobleColumna: {
            fontSize: 9.1,
            color: '#fff',
            fontWeight: 'bold',
        },
        productPriceContainerDobleColumna: {
            marginTop: 6,
        },
        productPriceLabelDobleColumna: {
            fontSize: 9.1,
            color: '#999',
            marginBottom: 1,
        },
        productPriceDobleColumna: {
            fontSize: 26,
            fontWeight: 'bold',
            color: colors.primary,
        },
        // Productos - Grid 3x3
        productsContainerGrid: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 8,
            justifyContent: 'center',
        },
        productCardGrid: {
            width: '31.5%',
            flexDirection: 'column',
            alignItems: 'center',
        },
        productImageGrid: {
            width: '80%',
            aspectRatio: 1,
            objectFit: 'cover',
            marginBottom: 6,
        },
        productDetailsGrid: {
            width: '80%',
        },
        productCategoryGrid: {
            fontSize: 7,
            color: '#888',
            marginBottom: 1,
        },
        productNameGrid: {
            fontSize: 11,
            fontWeight: 'bold',
            marginBottom: 1,
            color: '#000',
            textAlign: 'justify',
        },
        productCodeGrid: {
            fontSize: 7,
            color: '#999',
            marginBottom: 2,
        },
        productDescriptionGrid: {
            fontSize: 8,
            color: '#666',
            marginBottom: 4,
            lineHeight: 1.3,
            textAlign: 'justify',
        },
        productVariantsRowGrid: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 3,
        },
        productVariantLabelGrid: {
            fontSize: 7,
            color: '#666',
            fontWeight: 'bold',
            marginRight: 3,
            marginTop: 1,
        },
        productVariantBadgesGrid: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 2,
            flex: 1,
        },
        productVariantBadgeGrid: {
            backgroundColor: colors.primary,
            paddingHorizontal: 4,
            paddingVertical: 2,
            borderRadius: 2,
            marginRight: 2,
            marginBottom: 2,
        },
        productVariantTextGrid: {
            fontSize: 7,
            color: '#fff',
            fontWeight: 'bold',
        },
        productPriceContainerGrid: {
            marginTop: 4,
        },
        productPriceLabelGrid: {
            fontSize: 7,
            color: '#999',
            marginBottom: 1,
        },
        productPriceGrid: {
            fontSize: 16,
            fontWeight: 'bold',
            color: colors.primary,
        },
        // Estilos comunes de productos
        productImage: {
            width: '100%',
            height: 120,
            objectFit: 'contain',
            marginBottom: 8,
        },
        productImagePlaceholder: {
            width: '100%',
            height: 120,
            backgroundColor: '#000000',
            marginBottom: 8,
        },
        productName: {
            fontSize: 16,
            fontWeight: 'bold',
            marginBottom: 4,
            color: '#000',
        },
        productDescription: {
            fontSize: 9,
            color: '#666',
            marginBottom: 6,
            lineHeight: 1.3,
        },
        productPrice: {
            fontSize: 26,
            fontWeight: 'bold',
            color: colors.primary,
            marginTop: 4,
        },
        productPriceLabel: {
            fontSize: 8,
            color: '#999',
            marginBottom: 1,
        },
        productCode: {
            fontSize: 8,
            color: '#999',
            marginBottom: 3,
        },
        productVariantsRowContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: 6,
            marginTop: 6,
            marginBottom: 3,
        },
        productVariantsColumnContainer: {
            flexDirection: 'column',
            marginTop: 6,
            marginBottom: 3,
            gap: 4,
        },
        productVariantsRow: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 4,
            flex: 1,
        },
        productVariantLabel: {
            fontSize: 7,
            color: '#666',
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            minWidth: 45,
        },
        productVariantBadge: {
            backgroundColor: colors.primary,
            paddingHorizontal: 8,
            paddingVertical: 4,
            borderRadius: 4,
            marginRight: 4,
            marginBottom: 4,
        },
        productVariantText: {
            fontSize: 9,
            color: '#fff',
            fontWeight: 'bold',
        },
        productCategory: {
            fontSize: 8,
            color: '#888',
            marginBottom: 3,
            fontStyle: 'italic',
        },
        // Página de contacto
        contactPage: {
            padding: 0,
            position: 'relative',
        },
        contactHeader: {
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 40,
            paddingBottom: 30,
            paddingHorizontal: 30,
        },
        contactLogo: {
            width: 100,
            height: 100,
            borderRadius: 50,
            objectFit: 'cover',
            marginBottom: 15,
        },
        contactCompanyName: {
            fontSize: 28,
            fontWeight: 'bold',
            color: '#000',
            textAlign: 'center',
            marginBottom: 30,
        },
        contactInfoSection: {
            paddingHorizontal: 50,
            paddingBottom: 20,
        },
        contactInfoTitle: {
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000',
            marginBottom: 20,
            textAlign: 'center',
        },
        contactInfoGrid: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 15,
        },
        contactInfoColumn: {
            width: '48%',
        },
        contactInfoRow: {
            marginBottom: 15,
            alignItems: 'center',
        },
        contactInfoValue: {
            fontSize: 16,
            color: '#000',
            marginBottom: 4,
            textAlign: 'center',
        },
        contactInfoLabel: {
            fontSize: 12,
            color: '#666',
            textAlign: 'center',
        },
        qrSection: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: colors.primary,
            padding: 40,
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            minHeight: 280,
        },
        qrCard: {
            backgroundColor: '#ffffff',
            padding: 15,
            borderRadius: 12,
            alignItems: 'center',
            justifyContent: 'center',
        },
        qrImage: {
            width: 180,
            height: 180,
        },
        contactFooter: {
            position: 'absolute',
            bottom: 10,
            left: 0,
            right: 0,
            fontSize: 8,
            color: '#ffffff',
            textAlign: 'center',
            opacity: 0.8,
        },
    });

    // Calcular productos por página según layout
    const getProductsPerPage = () => {
        switch (config.layout) {
            case 'alternado': return 4;
            case 'doble-columna': return 4;
            case 'grid-3x3': return 9;
            default: return 6;
        }
    };

    const productsPerPage = getProductsPerPage();

    // Dividir productos en páginas
    const productPages = [];
    for (let i = 0; i < validProducts.length; i += productsPerPage) {
        productPages.push(validProducts.slice(i, i + productsPerPage));
    }


    // Renderizar producto para doble columna (diseño exclusivo)
    const renderProductDobleColumna = (product) => {
        // Obtener precio
        const prices = product.precios ? Object.values(product.precios) : [];
        const displayPrice = prices[0] || 'N/A';
        
        // Agrupar variantes por tipo
        const tallaVariants = product.variantes?.filter(v => 
            v.nombre?.toLowerCase().includes('talla') || 
            v.nombre?.match(/^(S|M|L|XL|XXL|\d+)$/i)
        ) || [];
        
        const colorVariants = product.variantes?.filter(v => 
            !tallaVariants.includes(v)
        ) || [];
        
        // Contar tipos de variantes
        const variantTypes = (tallaVariants.length > 0 ? 1 : 0) + (colorVariants.length > 0 ? 1 : 0);
        
        // Limpiar descripción - eliminar todos los saltos de línea
        let cleanedDescription = product.descripcion;
        if (cleanedDescription) {
            cleanedDescription = cleanedDescription.replace(/\n/g, ' ');
        }
        
        // Detectar si el nombre es largo (más de 22 caracteres)
        const isLongName = product.nombre && product.nombre.length > 22;
        
        // Truncar nombre si supera 38 caracteres - buscar siguiente espacio
        let displayName = product.nombre;
        if (displayName && displayName.length > 38) {
            // Buscar el siguiente espacio después del carácter 38
            const nextSpaceIndex = displayName.indexOf(' ', 38);
            if (nextSpaceIndex !== -1) {
                // Si encuentra un espacio, cortar hasta ahí
                displayName = displayName.substring(0, nextSpaceIndex);
            }
            // Si no encuentra espacio, mostrar todo (la palabra continúa)
        }
        
        // Ocultar descripción si nombre es largo Y tiene dos tipos de variantes
        const showDescription = !(isLongName && variantTypes === 2);
        
        // Limitar variantes según si tiene uno o dos tipos
        const maxColors = variantTypes === 2 ? 3 : 10;
        const maxTallas = variantTypes === 2 ? 5 : 10;
        const displayColorVariants = colorVariants.slice(0, maxColors);
        const displayTallaVariants = tallaVariants.slice(0, maxTallas);
        
        return (
            <View style={styles.productDetailsDobleColumna}>
                {/* Categoría > Subcategoría - Ocultar si nombre es largo */}
                {!isLongName && (product.categoria || product.subcategoria) && (
                    <Text style={styles.productCategoryDobleColumna}>
                        {product.categoria}{product.categoria && product.subcategoria && ' > '}{product.subcategoria}
                    </Text>
                )}
                
                {/* Nombre */}
                <Text style={styles.productNameDobleColumna}>
                    {displayName}
                </Text>
                
                {/* Referencia - SIEMPRE MOSTRAR */}
                <Text style={styles.productCodeDobleColumna}>
                    {product.codigo || '--'}
                </Text>
                
                {/* Descripción - Ocultar si nombre largo Y dos variantes */}
                {showDescription && cleanedDescription && (
                    <Text style={styles.productDescriptionDobleColumna}>
                        {cleanedDescription.substring(0, 100)}{cleanedDescription.length > 100 ? '...' : ''}
                    </Text>
                )}
                
                {/* Color: [Badges] */}
                {displayColorVariants.length > 0 && (
                    <View style={styles.productVariantsRowDobleColumna}>
                        <Text style={styles.productVariantLabelDobleColumna}>Color:</Text>
                        <View style={styles.productVariantBadgesDobleColumna}>
                            {displayColorVariants.map((v, i) => (
                                <View key={i} style={styles.productVariantBadgeDobleColumna}>
                                    <Text style={styles.productVariantTextDobleColumna}>
                                        {v.nombre}
                                    </Text>
                                </View>
                            ))}
                        </View>
                    </View>
                )}
                
                {/* Tallas: [Badges] */}
                {displayTallaVariants.length > 0 && (
                    <View style={styles.productVariantsRowDobleColumna}>
                        <Text style={styles.productVariantLabelDobleColumna}>Tallas:</Text>
                        <View style={styles.productVariantBadgesDobleColumna}>
                            {displayTallaVariants.map((v, i) => (
                                <View key={i} style={styles.productVariantBadgeDobleColumna}>
                                    <Text style={styles.productVariantTextDobleColumna}>
                                        {v.nombre?.replace('Talla ', '')}
                                    </Text>
                                </View>
                            ))}
                        </View>
                    </View>
                )}
                
                {/* Desde [Precio] - SIEMPRE MOSTRAR */}
                {displayPrice && (
                    <View style={[styles.productPriceContainerDobleColumna, isLongName && { marginTop: 2 }]}>
                        <Text style={styles.productPriceLabelDobleColumna}>Desde</Text>
                        <Text style={styles.productPriceDobleColumna}>
                            {displayPrice}
                        </Text>
                    </View>
                )}
            </View>
        );
    };

    // Renderizar producto para grid 3x3 (diseño exclusivo)
    const renderProductGrid = (product) => {
        // Obtener precio
        const prices = product.precios ? Object.values(product.precios) : [];
        const displayPrice = prices[0] || 'N/A';
        
        // Agrupar variantes por tipo
        const tallaVariants = product.variantes?.filter(v => 
            v.nombre?.toLowerCase().includes('talla') || 
            v.nombre?.match(/^(S|M|L|XL|XXL|\d+)$/i)
        ) || [];
        
        const colorVariants = product.variantes?.filter(v => 
            !tallaVariants.includes(v)
        ) || [];
        
        // Contar tipos de variantes
        const variantTypes = (tallaVariants.length > 0 ? 1 : 0) + (colorVariants.length > 0 ? 1 : 0);
        
        // Detectar si el nombre es largo (más de 22 caracteres)
        const isLongName = product.nombre && product.nombre.length > 22;
        
        // Limitar variantes según nombre largo y cantidad de variantes
        let maxColors, maxTallas, showDescription;
        
        if (isLongName && variantTypes === 2) {
            // Nombre largo + dos variantes: máximo 3 colores, 5 tallas, sin descripción
            maxColors = 3;
            maxTallas = 5;
            showDescription = false;
        } else if (isLongName && variantTypes === 1) {
            // Nombre largo + una variante: máximo 6 colores o 10 tallas
            maxColors = 6;
            maxTallas = 10;
            // Ocultar descripción si hay más de 3 colores O más de 5 tallas
            showDescription = !(colorVariants.length > 3 || tallaVariants.length > 5);
        } else {
            // Nombre corto o sin variantes: mostrar todo
            maxColors = colorVariants.length;
            maxTallas = tallaVariants.length;
            showDescription = true;
        }
        
        const displayColorVariants = colorVariants.slice(0, maxColors);
        const displayTallaVariants = tallaVariants.slice(0, maxTallas);
        
        // Limpiar descripción - eliminar todos los saltos de línea
        let cleanedDescription = product.descripcion;
        if (cleanedDescription) {
            cleanedDescription = cleanedDescription.replace(/\n/g, ' ');
        }
        
        return (
            <View style={styles.productDetailsGrid}>
                {/* Nombre */}
                <Text style={styles.productNameGrid}>
                    {product.nombre}
                </Text>
                
                {/* Referencia - SIEMPRE MOSTRAR */}
                <Text style={styles.productCodeGrid}>
                    {product.codigo || '--'}
                </Text>
                
                {/* Descripción - Ocultar si nombre largo Y dos variantes */}
                {showDescription && cleanedDescription && (
                    <Text style={styles.productDescriptionGrid}>
                        {cleanedDescription.substring(0, 68)}{cleanedDescription.length > 68 ? '...' : ''}
                    </Text>
                )}
                
                {/* Color: [Badges] */}
                {displayColorVariants.length > 0 && (
                    <View style={styles.productVariantsRowGrid}>
                        <Text style={styles.productVariantLabelGrid}>Color:</Text>
                        <View style={styles.productVariantBadgesGrid}>
                            {displayColorVariants.map((v, i) => (
                                <View key={i} style={styles.productVariantBadgeGrid}>
                                    <Text style={styles.productVariantTextGrid}>
                                        {v.nombre}
                                    </Text>
                                </View>
                            ))}
                        </View>
                    </View>
                )}
                
                {/* Tallas: [Badges] */}
                {displayTallaVariants.length > 0 && (
                    <View style={styles.productVariantsRowGrid}>
                        <Text style={styles.productVariantLabelGrid}>Tallas:</Text>
                        <View style={styles.productVariantBadgesGrid}>
                            {displayTallaVariants.map((v, i) => (
                                <View key={i} style={styles.productVariantBadgeGrid}>
                                    <Text style={styles.productVariantTextGrid}>
                                        {v.nombre?.replace('Talla ', '')}
                                    </Text>
                                </View>
                            ))}
                        </View>
                    </View>
                )}
                
                {/* Desde [Precio] - SIEMPRE MOSTRAR */}
                {displayPrice && (
                    <View style={styles.productPriceContainerGrid}>
                        <Text style={styles.productPriceLabelGrid}>Desde</Text>
                        <Text style={styles.productPriceGrid}>
                            {displayPrice}
                        </Text>
                    </View>
                )}
            </View>
        );
    };


    // Renderizar producto para layout alternado (con toda la info)
    const renderProductAlternado = (product, index) => {
        const isReverse = index % 2 !== 0;
        
        // Obtener precio único o múltiple
        const prices = product.precios ? Object.values(product.precios) : [];
        const displayPrice = prices[0] || 'N/A';
        
        // Agrupar variantes por tipo
        const tallaVariants = product.variantes?.filter(v => 
            v.nombre?.toLowerCase().includes('talla') || 
            v.nombre?.match(/^(S|M|L|XL|XXL|\d+)$/i)
        ) || [];
        
        const colorVariants = product.variantes?.filter(v => 
            !tallaVariants.includes(v)
        ) || [];
        
        // Contar tipos de variantes
        const variantTypes = (tallaVariants.length > 0 ? 1 : 0) + (colorVariants.length > 0 ? 1 : 0);
        
        // Detectar si el nombre es largo (más de 22 caracteres)
        const isLongName = product.nombre && product.nombre.length > 22;
        
        // Limpiar descripción (solo si nombre es largo)
        let cleanedDescription = product.descripcion;
        if (cleanedDescription && isLongName) {
            if (variantTypes === 0) {
                // Productos sin variantes: Eliminar saltos de línea antes de 47 caracteres y permitir solo uno
                const firstPart = cleanedDescription.substring(0, 47);
                const restPart = cleanedDescription.substring(47);
                cleanedDescription = firstPart.replace(/\n/g, ' ') + restPart;
                
                // Permitir solo un \n en toda la descripción
                const parts = cleanedDescription.split('\n');
                if (parts.length > 2) {
                    cleanedDescription = parts[0] + '\n' + parts.slice(1).join(' ');
                }
            } else {
                // Productos con una o dos variantes: Eliminar todos los saltos de línea
                cleanedDescription = cleanedDescription.replace(/\n/g, ' ');
            }
        } else if (cleanedDescription && !isLongName && variantTypes > 0) {
            // Si nombre NO es largo pero tiene variantes, también eliminar saltos de línea
            cleanedDescription = cleanedDescription.replace(/\n/g, ' ');
        }
        
        // Tamaños dinámicos según cantidad de variantes
        let nameFontSize, descriptionFontSize, codeFontSize, priceFontSize, categoryFontSize, priceLabelFontSize;
        let showCategory = true;
        
        if (variantTypes === 0) {
            if (isLongName) {
                // Nombre largo - Reducir todo 10% y ocultar categoría
                nameFontSize = 21.6; // 24 * 0.9
                descriptionFontSize = 12.15; // 13.5 * 0.9
                codeFontSize = 10.8; // 12 * 0.9
                categoryFontSize = 10.8; // 12 * 0.9
                priceLabelFontSize = 10.8; // 12 * 0.9
                priceFontSize = 32.76; // 36.4 * 0.9
                showCategory = false;
            } else {
                // Sin variantes - MÁXIMO TAMAÑO (+50% en todo, -20% en precio)
                nameFontSize = 24; // 16 * 1.5
                descriptionFontSize = 13.5; // 9 * 1.5
                codeFontSize = 12; // 8 * 1.5
                categoryFontSize = 12; // 8 * 1.5
                priceLabelFontSize = 12; // 8 * 1.5
                priceFontSize = 36.4; // 45.5 * 0.8
            }
        } else if (variantTypes === 1) {
            // Una variante - TAMAÑO MEDIO (+10%) - Ocultar categoría solo si nombre largo
            nameFontSize = 17.6;
            descriptionFontSize = 9.9;
            codeFontSize = 8.8;
            categoryFontSize = 8;
            priceLabelFontSize = 8;
            priceFontSize = 39; // +50%
            if (isLongName) {
                showCategory = false;
            }
        } else {
            // Dos variantes - TAMAÑO BASE - Ocultar categoría solo si nombre largo
            nameFontSize = 16;
            descriptionFontSize = 9;
            codeFontSize = 8;
            categoryFontSize = 8;
            priceLabelFontSize = 8;
            priceFontSize = 26;
            if (isLongName) {
                showCategory = false;
            }
        }
        
        return (
            <View style={isReverse ? styles.productInfoAlternadoRight : styles.productInfoAlternado}>
                {/* Categoría con tamaño dinámico - Ocultar si nombre es largo O dos variantes */}
                {showCategory && (product.categoria || product.subcategoria) && (
                    <Text style={[styles.productCategory, { fontSize: categoryFontSize }]}>
                        {product.categoria}{product.categoria && product.subcategoria && ' > '}{product.subcategoria}
                    </Text>
                )}
                
                {/* Nombre con tamaño dinámico */}
                <Text style={[styles.productName, { fontSize: nameFontSize }]}>
                    {product.nombre}
                </Text>
                
                {/* Código con tamaño dinámico - SIEMPRE MOSTRAR */}
                <Text style={[styles.productCode, { fontSize: codeFontSize }]}>
                    Ref: {product.codigo || '--'}
                </Text>
                
                {/* Descripción con tamaño dinámico - Ocultar si nombre largo Y dos variantes */}
                {!(isLongName && variantTypes === 2) && cleanedDescription && (
                    <Text style={[styles.productDescription, { fontSize: descriptionFontSize }]}>
                        {cleanedDescription.substring(0, 114)}{cleanedDescription.length > 114 ? '...' : ''}
                    </Text>
                )}
                
                {/* Variantes de Talla */}
                {tallaVariants.length > 0 && (
                    <View style={[
                        (variantTypes === 1 && !isLongName) ? styles.productVariantsColumnContainer : styles.productVariantsRowContainer,
                        isReverse && { alignSelf: 'flex-start', width: '100%' }
                    ]}>
                        <Text style={styles.productVariantLabel}>Tallas:</Text>
                        <View style={styles.productVariantsRow}>
                            {tallaVariants.map((v, i) => (
                                <View key={i} style={styles.productVariantBadge}>
                                    <Text style={styles.productVariantText}>
                                        {v.nombre?.replace('Talla ', '')}
                                    </Text>
                                </View>
                            ))}
                        </View>
                    </View>
                )}
                
                {/* Variantes de Color */}
                {colorVariants.length > 0 && (
                    <View style={[
                        (variantTypes === 1 && !isLongName) ? styles.productVariantsColumnContainer : styles.productVariantsRowContainer,
                        isReverse && { alignSelf: 'flex-start', width: '100%' }
                    ]}>
                        <Text style={styles.productVariantLabel}>Colores:</Text>
                        <View style={styles.productVariantsRow}>
                            {colorVariants.map((v, i) => (
                                <View key={i} style={styles.productVariantBadge}>
                                    <Text style={styles.productVariantText}>
                                        {v.nombre}
                                    </Text>
                                </View>
                            ))}
                        </View>
                    </View>
                )}
                
                {/* Precio con tamaño dinámico - SIEMPRE MOSTRAR */}
                {displayPrice && (
                    <View style={{ marginTop: 'auto' }}>
                        <Text style={[styles.productPriceLabel, { fontSize: priceLabelFontSize }, variantTypes === 1 && { marginBottom: 0 }]}>Desde</Text>
                        <Text style={[styles.productPrice, { fontSize: priceFontSize }, variantTypes === 1 && { marginTop: 0 }]}>
                            {displayPrice}
                        </Text>
                    </View>
                )}
            </View>
        );
    };

    return (
        <Document>
            {/* Portada */}
            {config.coverType === 'generated' ? (
                <Page size="A4" style={styles.coverPage}>
                    <View style={styles.coverContent}>
                        {/* Figuras decorativas simples */}
                        <View style={styles.coverSquare} />
                        <View style={styles.coverTriangle} />
                        
                        {/* Título superior - Nombre del catálogo */}
                        <Text style={styles.coverTitle}>{catalog?.name?.toUpperCase() || 'CATÁLOGO'}</Text>
                        
                        {/* Contenedor de imagen 1:1 con borde blanco */}
                        <View style={styles.coverImageContainer}>
                            {validProducts[0]?.imagenes?.[0] ? (
                                <Image 
                                    src={validProducts[0].imagenes[0]} 
                                    style={styles.coverImage}
                                />
                            ) : (
                                <View style={styles.coverImagePlaceholder} />
                            )}
                        </View>
                        
                        {/* Descripción en la parte inferior */}
                        {catalog?.description && (
                            <Text style={styles.coverYear}>{catalog.description}</Text>
                        )}
                    </View>
                </Page>
            ) : config.coverType === 'banner' && catalog?.bannerUrl ? (
                <Page size="A4" style={styles.coverPage}>
                    <View style={{ width: '100%', height: '100%', position: 'relative' }}>
                        <Image 
                            src={catalog.bannerUrl} 
                            style={styles.bannerImage}
                        />
                    </View>
                </Page>
            ) : null}

            {/* Páginas de productos */}
            {productPages.map((pageProducts, pageIndex) => (
                <Page key={`page-${pageIndex}`} size="A4" style={styles.page}>
                    {/* Círculos decorativos de fondo */}
                    <View style={styles.backgroundCircle1} />
                    <View style={styles.backgroundCircle2} />
                    <View style={styles.backgroundCircle3} />
                    <View style={styles.backgroundCircle5} />
                    <View style={styles.backgroundCircle6} />
                    
                    {/* Layout Alternado */}
                    {config.layout === 'alternado' && (
                        <View style={styles.productsContainerAlternado}>
                            {pageProducts.map((product, productIndex) => (
                                <View 
                                    key={`product-${productIndex}`}
                                    style={productIndex % 2 === 0 ? styles.productCardAlternado : styles.productCardAlternadoReverse}
                                >
                                    <Image 
                                        src={product.imagenes?.[0] || 'https://cdn.minymol.com/uploads/a8dd70aa-b892-4f55-b17c-e1b0270779f8.webp'}
                                        style={styles.productImageAlternado}
                                    />
                                    {renderProductAlternado(product, productIndex)}
                                </View>
                            ))}
                        </View>
                    )}
                    
                    {/* Layout Doble Columna */}
                    {config.layout === 'doble-columna' && (
                        <View style={styles.productsContainerDobleColumna}>
                            {pageProducts.map((product, productIndex) => (
                                <View key={`product-${productIndex}`} style={styles.productCardDobleColumna}>
                                    {/* Imagen */}
                                    <Image 
                                        src={product.imagenes?.[0] || 'https://cdn.minymol.com/uploads/a8dd70aa-b892-4f55-b17c-e1b0270779f8.webp'}
                                        style={styles.productImageDobleColumna}
                                    />
                                    {/* Detalles */}
                                    {renderProductDobleColumna(product)}
                                </View>
                            ))}
                        </View>
                    )}
                    
                    {/* Layout Grid 3x3 */}
                    {config.layout === 'grid-3x3' && (
                        <View style={styles.productsContainerGrid}>
                            {pageProducts.map((product, productIndex) => (
                                <View key={`product-${productIndex}`} style={styles.productCardGrid}>
                                    {/* Imagen */}
                                    <Image 
                                        src={product.imagenes?.[0] || 'https://cdn.minymol.com/uploads/a8dd70aa-b892-4f55-b17c-e1b0270779f8.webp'}
                                        style={styles.productImageGrid}
                                    />
                                    {/* Detalles */}
                                    {renderProductGrid(product)}
                                </View>
                            ))}
                        </View>
                    )}
                </Page>
            ))}

            {/* Página de contacto */}
            {config.showContactPage && providerInfo && (
                <Page size="A4" style={styles.contactPage}>
                    {/* Header con logo circular y nombre centrado */}
                    <View style={styles.contactHeader}>
                        {circularLogo && (
                            <Image 
                                src={circularLogo} 
                                style={styles.contactLogo}
                            />
                        )}
                        <Text style={styles.contactCompanyName}>
                            {providerInfo.nombre_empresa}
                        </Text>
                    </View>
                    
                    {/* Información de contacto */}
                    <View style={styles.contactInfoSection}>
                        <Text style={styles.contactInfoTitle}>Contacto</Text>
                        
                        <View style={styles.contactInfoGrid}>
                            {/* Columna izquierda */}
                            <View style={styles.contactInfoColumn}>
                                {providerInfo.telefono && (
                                    <View style={styles.contactInfoRow}>
                                        <Text style={styles.contactInfoValue}>
                                            {providerInfo.telefono}
                                        </Text>
                                        <Text style={styles.contactInfoLabel}>
                                            Teléfono
                                        </Text>
                                    </View>
                                )}
                                
                                {providerInfo.direccion && (
                                    <View style={styles.contactInfoRow}>
                                        <Text style={styles.contactInfoValue}>
                                            {providerInfo.direccion}
                                        </Text>
                                        <Text style={styles.contactInfoLabel}>
                                            Dirección
                                        </Text>
                                    </View>
                                )}
                            </View>
                            
                            {/* Columna derecha */}
                            <View style={styles.contactInfoColumn}>
                                {providerInfo.email && (
                                    <View style={styles.contactInfoRow}>
                                        <Text style={styles.contactInfoValue}>
                                            {providerInfo.email}
                                        </Text>
                                        <Text style={styles.contactInfoLabel}>
                                            Correo
                                        </Text>
                                    </View>
                                )}
                                
                                {(providerInfo.ciudad || providerInfo.departamento) && (
                                    <View style={styles.contactInfoRow}>
                                        <Text style={styles.contactInfoValue}>
                                            {providerInfo.ciudad}{providerInfo.ciudad && providerInfo.departamento && ', '}{providerInfo.departamento}
                                        </Text>
                                        <Text style={styles.contactInfoLabel}>
                                            Ciudad, Departamento
                                        </Text>
                                    </View>
                                )}
                            </View>
                        </View>
                    </View>
                    
                    {/* Sección de QR codes */}
                    <View style={styles.qrSection}>
                        {/* QR WhatsApp */}
                        {qrWhatsApp && (
                            <View style={styles.qrCard}>
                                <Image 
                                    src={qrWhatsApp} 
                                    style={styles.qrImage}
                                />
                            </View>
                        )}
                        
                        {/* QR Catálogo */}
                        {qrCatalog && (
                            <View style={styles.qrCard}>
                                <Image 
                                    src={qrCatalog} 
                                    style={styles.qrImage}
                                />
                            </View>
                        )}
                        
                        {/* Footer pequeño */}
                        <Text style={styles.contactFooter}>
                            Generado por OviCatalogos - Un sistema Minymol S.A.S. - NIT: 901964524-2
                        </Text>
                    </View>
                </Page>
            )}
        </Document>
    );
};

export default PDFDocument;
